const analyticEventData = {
  eventAction: "cart:landing page:share cart",
  eventName: "cart:landing page:share cart",
  internalLinkPosition: "cart",
  internalLinkType: "cart:navigation",
  internalLinkZoneName: "cart:landing page:order summary",
}

export { analyticEventData }
